var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.676,
    height: 256.017,
    viewBox: "0 0 138.676 256.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Generic_Mobile_Phone-100",
    "data-name": "Generic Mobile Phone-100",
    d: "M28,1A16.083,16.083,0,0,0,12,17V241.016a16.083,16.083,0,0,0,16,16H134.675a16.083,16.083,0,0,0,16-16V17a16.083,16.083,0,0,0-16-16Zm0,10.667H134.675A5.249,5.249,0,0,1,140.008,17V241.016a5.249,5.249,0,0,1-5.334,5.334H28a5.249,5.249,0,0,1-5.334-5.334V17A5.249,5.249,0,0,1,28,11.667ZM81.338,22.335a5.334,5.334,0,1,0,5.334,5.334A5.334,5.334,0,0,0,81.338,22.335Z",
    transform: "translate(-12 -1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.efb475eba747611e5bbc808836aa8c36.svg";
export { ForwardRef as ReactComponent };